<app-request-button *ngIf="requestStatus === 0" (sendRequest)="sendPatientRequest()"></app-request-button>
<button *ngIf="requestStatus === 1" mat-raised-button color="primary">
  <i class="fa fa-spinner fa-spin fa-pulse"></i>
</button>
<button disabled *ngIf="requestStatus === 2" mat-raised-button color="green">
  <i class="fa fa-check"></i>
</button>
